import React, { useState, useRef, useEffect } from "react";
import Container from "@mui/material/Container";
import { Box, Typography, IconButton } from "@mui/material";
import Slider from "react-slick";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import ArrowForwardIcon from '@mui/icons-material/ArrowForward';
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

import video1 from "../images/intro-video.mp4";
import video2 from "../images/guide-video.mp4";
import video3 from "../images/ambd-video.mp4";

import useStyles from "../css/videoStyle";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

function CustomPaging() {
    const classes = useStyles;
    const videos = [video1, video2, video3]; // Array with one video
    const [sliderRef, setSliderRef] = useState(null);
    const [currentSlide, setCurrentSlide] = useState(0);
    const dotsContainerRef = useRef(null);

    useEffect(() => {
        if (dotsContainerRef.current) {
            console.log("dotsContainerRef width:", dotsContainerRef.current.scrollWidth);
            console.log("dotsContainerRef client width:", dotsContainerRef.current.clientWidth);
        }
    }, [dotsContainerRef]);

    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        // vertical: true,
        // verticalSwiping: true, // Fixes vertical video glitches
        arrows: false,
        adaptiveHeight: true, // Adjust height for videos
        beforeChange: (current, next) => setCurrentSlide(next),
        responsive: [
            {
                breakpoint: 768, // For mobile screens
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    vertical: false, // Use horizontal slider on small screens
                    verticalSwiping: false,
                },
            },
        ],
    };


    // const settings = {
    //     dots: false,
    //     infinite: true, // Enable infinite looping even if there's only one video
    //     speed: 500,
    //     slidesToShow: 1,
    //     slidesToScroll: 1,
    //     vertical: true, // Enable vertical slider
    //     arrows: false, // Hide arrows for now
    //     beforeChange: (current, next) => setCurrentSlide(next),
    // };

    const handleNext = () => {
        if (sliderRef) sliderRef.slickNext();
    };

    const handlePrevious = () => {
        if (sliderRef) sliderRef.slickPrev();
    };

    const handleThumbnailClick = (index) => {
        if (sliderRef) {
            sliderRef.slickGoTo(index);
        }
    };

    const scrollDots = (direction) => {
        const container = dotsContainerRef.current;
        if (container) {
            container.scrollBy({
                top: direction === "up" ? -150 : 150,
                behavior: "smooth",
            });
            console.log("Scrolled", direction, "by 150px");
        }
    };

    return (
        <Container>
            <Box id="Videos" sx={classes.container}>
                <Typography variant="h2" sx={classes.heading}>Guide videos</Typography>
                <Typography variant="body1" sx={classes.subHeading}>
                    Please watch our Guide Videos to sign up and subscribe today
                </Typography>
                <Box sx={classes.divider}></Box>
            </Box>

            <Box sx={classes.sliderContainer}>
                {/* Left Navigation Icon */}
                <IconButton
                    sx={classes.leftIcon}
                    onClick={handlePrevious}
                    disabled={currentSlide === 0}
                >
                    <ArrowBackIosIcon sx={{ color: '#333333', fontSize: '50px' }} />
                </IconButton>

                {/* Main Slider with Videos */}
                <Slider {...settings} ref={(slider) => setSliderRef(slider)}>
                    {videos.map((video, index) => (
                        <div key={index}>
                            <video
                                src={video}
                                controls
                                style={{ width: "100%", borderRadius: "8px" }}
                                alt={`Video ${index + 1}`}
                            />
                        </div>
                    ))}
                </Slider>

                {/* Right Navigation Icon */}
                <IconButton
                    sx={classes.rightIcon}
                    onClick={handleNext}
                    disabled={currentSlide === videos.length - 1}
                >
                    <ArrowForwardIosIcon sx={{ color: '#333333', fontSize: '50px' }} />
                </IconButton>
            </Box>

            <Box sx={{ mt: 5 }}>
                {/* Thumbnail Strip */}
                <Box ref={dotsContainerRef} sx={classes.thumbnailStrip}>
                    {videos.map((video, index) => (
                        <Box
                            key={index}
                            sx={{ ...classes.thumbnail(currentSlide === index), position: "relative" }}
                            onClick={() => handleThumbnailClick(index)}
                        >
                            <video
                                src={video}
                                style={classes.thumbnailImage}
                                loop
                            />
                            {/* Centered Play Icon Overlay */}
                            <PlayCircleOutlineIcon sx={classes.iconOverlay} />
                        </Box>
                    ))}
                </Box>


                {/* Dots and Navigation Icons */}
                <Box sx={classes.dotsAndNavigation}>
                    <IconButton onClick={() => scrollDots("up")}>
                        <ArrowBackIcon sx={{ color: '#333333', fontSize: '30px' }} />
                    </IconButton>

                    <Box sx={classes.dotContainer}>
                        {videos.map((_, index) => (
                            <Box
                                key={index}
                                sx={classes.dot(currentSlide === index)}
                                onClick={() => handleThumbnailClick(index)}
                            />
                        ))}
                    </Box>

                    <IconButton onClick={() => scrollDots("down")}>
                        <ArrowForwardIcon sx={{ color: '#333333', fontSize: '30px' }} />
                    </IconButton>
                </Box>
            </Box>
        </Container>
    );
}

export default CustomPaging;
